import { supabase } from '../utils/supabase';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://qpalpdncuownwqknszro.supabase.co';
const EDGE_FUNCTION_BASE_URL = `${SUPABASE_URL}/functions/v1`;

/**
 * Generic function to call admin Edge Functions
 * Automatically includes JWT token from current session
 */
async function callAdminFunction(functionName) {
  try {
    // Get current session to retrieve JWT token
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();

    if (sessionError) {
      throw new Error(`Session error: ${sessionError.message}`);
    }

    if (!session?.access_token) {
      throw new Error('No active session. Please log in.');
    }

    const response = await fetch(
      `${EDGE_FUNCTION_BASE_URL}/${functionName}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(errorData.error || `Failed to fetch from ${functionName} (${response.status})`);
    }

    const result = await response.json();
    return result.data || [];
  } catch (error) {
    console.error(`Error calling ${functionName}:`, error);
    throw error;
  }
}

/**
 * Fetch all users from email_signups table
 * @returns {Promise<Array>} Array of user records
 */
export async function fetchAdminUsers() {
  return callAdminFunction('get-admin-users');
}

/**
 * Fetch all quote requests
 * @returns {Promise<Array>} Array of quote records
 */
export async function fetchAdminQuotes() {
  return callAdminFunction('get-admin-quotes');
}

/**
 * Fetch all pole calculations
 * @returns {Promise<Array>} Array of calculation records
 */
export async function fetchAdminCalculations() {
  return callAdminFunction('get-admin-calculations');
}
